<app-admin-menu></app-admin-menu>

<h1 class="mat-headline-3">Scheman</h1>

<div class="container">
    <div class="row">
        <div class="col">
            <mat-card class="compact schedules-list">
                <mat-card-content>
                    <app-schedules-list (filterChanged)="updateQueryParameters($event)" [query]="query"
                    [lengths]="lengths" [page]="page">
                    </app-schedules-list>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<app-messages #messagesPartial [employeeId]="employeeId"></app-messages>

<app-admin-footer></app-admin-footer>
